import React from "react";
import { FormattedMessage } from "react-intl";
import Layout from "../layout";
import Menu from "../menu";
import BoughtDocumentsHeader from "../../general/boughtDocumentsHeader";
import "./style.scss";

interface PageProps {
    title?: string;
    subtitle?: string;
    backFunction?: () => void;
    backText?: string;
    children?: React.ReactNode;
    showMenu?: boolean;
    showBoughtDocuments?: boolean;
    withPadding?: boolean;
    expanded?: boolean;
    setExpanded?: (val: boolean) => void;
}

const Page = (props: PageProps) => {
    const sidebarItems = [
        {
            value: "buy",
            icon: "shopping-cart",
            label: <FormattedMessage id="menu.buy" />,
            path: "/",
        },
        {
            value: "documents",
            icon: "folder",
            label: <FormattedMessage id="menu.documents" />,
            path: "/documenti",
        },
    ];

    return (
        <div className="vapor_page-root">
            {props.showMenu && <Menu items={sidebarItems} />}
            {props.showBoughtDocuments && (
                <BoughtDocumentsHeader
                    expanded={props.expanded}
                    setExpanded={props.setExpanded}
                />
            )}
            <Layout withMargin withPadding={props.withPadding}>
                {props.children}
            </Layout>
        </div>
    );
};

Page.defaultProps = {
    showMenu: true,
    withPadding: false,
};

export default Page;
